module.exports = __webpack_public_path__ + "components/homepage-hero/static/icon-search-4bd4ca7efc7257291d7e88b8fe13005f.svg";